import { render, staticRenderFns } from "./pricePackageForm.vue?vue&type=template&id=4b2d5a49&scoped=true&"
import script from "./pricePackageForm.vue?vue&type=script&lang=js&"
export * from "./pricePackageForm.vue?vue&type=script&lang=js&"
import style0 from "./pricePackageForm.vue?vue&type=style&index=0&id=4b2d5a49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2d5a49",
  null
  
)

export default component.exports